import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ErrorBoundary from "@/components/ErrorBoundary";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Assujettis from "@/pages/Assujettis";
import Actes from "@/pages/Actes";
import NotesDebit from "@/pages/NotesDebit";
import NotesApurement from "@/pages/NotesApurement";
import Utilisateurs from "@/pages/Utilisateurs";
import Parametres from "@/pages/Parametres";
import Rapports from "@/pages/Rapports";
import ExtraitCompte from "@/pages/ExtraitCompte";
import PrintNoteDebit from "@/pages/PrintNoteDebit";
import PrintNoteApurement from "@/pages/PrintNoteApurement";
import "@/App.css";

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/print/note-debit/:id"
            element={
              <ProtectedRoute>
                <PrintNoteDebit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/print/note-apurement/:id"
            element={
              <ProtectedRoute>
                <PrintNoteApurement />
              </ProtectedRoute>
            }
          />
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<Dashboard />} />
            <Route path="/assujettis" element={<Assujettis />} />
            <Route path="/actes" element={<Actes />} />
            <Route path="/notes-debit" element={<NotesDebit />} />
            <Route path="/notes-apurement" element={<NotesApurement />} />
            <Route path="/rapports" element={<Rapports />} />
            <Route path="/extrait" element={<ExtraitCompte />} />
            <Route
              path="/utilisateurs"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <Utilisateurs />
                </ProtectedRoute>
              }
            />
            <Route
              path="/parametres"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <Parametres />
                </ProtectedRoute>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
